export default "__VITE_ASSET__CuR_e_zq__"